module.exports = __webpack_public_path__ + "static/media/jd.dca19d98.svg";